import React from 'react';
import { Link } from 'react-router-dom';
import { PlusIcon } from '@heroicons/react/24/outline';

function Campaigns() {
	return (
		<div className="space-y-6">
			<div className="md:flex md:items-center md:justify-between">
				<div className="min-w-0 flex-1">
					<h2 className="text-2xl font-bold leading-7 text-gray-900 sm:truncate sm:text-3xl sm:tracking-tight">
						广告系列管理
					</h2>
					<p className="mt-1 text-sm text-gray-500">
						管理您的 Facebook Page Like 广告系列
					</p>
				</div>
				<div className="mt-4 flex md:ml-4 md:mt-0">
					<Link
						to="/campaigns/create"
						className="btn-primary"
					>
						<PlusIcon className="h-4 w-4 mr-2" />
						创建广告系列
					</Link>
				</div>
			</div>
			
			<div className="bg-white shadow rounded-lg p-6">
				<p className="text-gray-600">广告系列列表正在开发中...</p>
			</div>
		</div>
	);
}

export default Campaigns;
